// extracted by mini-css-extract-plugin
module.exports = {"skeleton-box":"style_skeleton-box__a_moK","skeleton-box--hexagon":"style_skeleton-box--hexagon__zJsYS","shimmer":"style_shimmer__cUlCU"};